import React from 'react';
import { ErrorFallbackMsg } from './error-msg';

export interface ErrorBoundaryState {
  hasError: boolean;
  error: string;
}

export interface ErrorBoundaryProps {
  errorRenderer?: (error: string) => React.ReactNode;
}

export class ErrorBoundary<T = {}> extends React.Component<
  React.PropsWithChildren<T> & ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: React.PropsWithChildren<T> & ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: '' };
  }

  static getDerivedStateFromError(error: Error) {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return { hasError: true, error: error.message };
  }

  //   componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {}

  render() {
    if (this.state.hasError) {
      // 你可以自定义降级后的 UI 并渲染
      return this.props.errorRenderer ? (
        this.props.errorRenderer(this.state.error)
      ) : (
        <ErrorFallbackMsg error={this.state.error} />
      );
    }

    return this.props.children;
  }
}
